import { GET_USER_ROLE } from "ActionTypes";

export const getCurrentUserRole = (data) => (dispatch) => {
  dispatch({
    type: GET_USER_ROLE,
    payload: data,
  });
};
